export default __webpack_public_path__ + "static/media/blackout.ae00bd6d.png";